import { render } from "./TestLoaders.vue?vue&type=template&id=61b13e01"
import script from "./TestLoaders.vue?vue&type=script&lang=js"
export * from "./TestLoaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__